export default "__VITE_ASSET__20c7bacb__"